import { forwardRef } from 'react';
import { useLocalization } from '@ui-framework/index';
import SelectStatic from './SelectStatic';

const OptionsSelect = forwardRef(({ field, ...props }, ref) => {
  const { formatMessage } = useLocalization();
  const options = (field.options || []).map(option => ({
    ...option,
    label: option.label?.localeId
      ? formatMessage({
          id: option.label.localeId,
          defaultMessage: option.label.defaultMessage,
        })
      : option.label,
  }));
  return (
    <SelectStatic
      ref={ref}
      field={field}
      customConfig={{ options }}
      {...props}
    />
  );
});

export default OptionsSelect;
